<template>
  <div>
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">Posting</h6>
          <div class="element-box">
            <div class="element-info">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <div class="os-icon os-icon-file">
                      </div>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">Posting Track</h5>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 posting-tracker-alerts pt-4">
                  <div class="posting-tracker-alert" v-for="(alert, idx) in alerts" :key="idx">
                    <b-alert :variant="alert.status" :show="alert.status != null">
                      <span>{{alert.message}}</span>
                    </b-alert>
                  </div>
                </div>

              </div>
            </div>

            <b-collapse v-model="isFilterVisible" id="search" >
              <div id="posting-track-filter">
                <form v-on:submit.prevent="">
                  <div class="row">
                    <div class="col-md-2">
                      <div  class="form-group">
                        <label for="filter-client" class="d-block text-center">Client</label>
                        <select id="filter-client" class="form-control custom-select text-capitalize" @change="onClientChange" v-model="filterData.client">
                          <option selected="selected" value="">Select all</option>
                          <option v-for="c of postingTrackerFilter.clients" :value="c.short_name" :key="c.short_name">{{c.postroom_label}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label for="filter-batches" class="d-block text-center">Batch</label>
                        <div class="multiselect-default">
                          <multiselect
                              v-model="filterData.batches"
                              select-label=""
                              deselect-label=""
                              :options="postingTrackerFilter.batches"
                              :multiple="true"
                              :limit="1"
                              placeholder=""
                              label="reference"
                              track-by="id"
                          ></multiselect>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div  class="form-group">
                        <label for="filter-date-from" class="d-block text-center">From</label>
                        <datePicker v-model="filterData.from" class="form-control text-center" :config="datePickerFrom" placeholder="From"></datePicker>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div  class="form-group">
                        <label for="filter-date-to" class="d-block text-center">To</label>
                        <datePicker v-model="filterData.to" class="form-control text-center" :config="datePickerTo" placeholder="To"></datePicker>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div  class="form-group">
                        <label for="filter-completed" class="d-block text-center">Completed</label>
                        <select id="filter-completed" class="form-control custom-select text-capitalize" v-model="filterData.completed">
                          <option selected="selected" value="">---</option>
                          <option value="y">Yes</option>
                          <option value="n">No</option>
                        </select>
                      </div>
                    </div>

                  </div>
                </form>
              </div>
            </b-collapse>

            <div class="row">
              <div class="input-group col-lg-2 col-md-4 col-sm-12 mb-2 mb-md-0">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    {{ t('recordsPerPageText','recordsPerPageText') }}
                  </div>
                </div>
                <input class="form-control" type="number" min="1" v-model="perPage" :placeholder="perPage" @change="onPerPageChange">
              </div>
              <div class="col-lg-10 col-md-8 col-sm-12 mb-2 mb-md-0" style="text-align: right;">
                <div class="form-group">
                  <button @click="loadPostingTracker" class="btn btn-primary">Search</button>
                </div>
              </div>
            </div>
            <hr>
            <b-table id="posting-tracker-table" striped hover bordered :fields="fields" :busy.sync="loading" :items="postingTracker" :currentPage="currentPage" :filter="filter" @filtered="onFiltered" :tbody-tr-attr="getRowClass" :show-empty="true">
              <template slot="thead-top" slot-scope="data">
                <tr>
                  <th colspan="4"></th>
                  <th colspan="7">Number of documents</th>
                  <th colspan="3">Selling price(£)</th>
                  <th colspan="3">Completed</th>
                </tr>
              </template>

              <template class="busy-row" slot="table-busy" slot-scope="items" v-bind:value="postingTracker">
                <vcl-table :rows="3" :columns="17"></vcl-table>
              </template>

              <template v-slot:cell(nb_of_docs_uk)="data">
                <div class="input-group input-group-sm single-number-field">
                  <input type="number" min="0" step="1" v-model="data.item.uk_mail" class="form-control" @change="calcResult(data.item)" />
                </div>
              </template>

              <template v-slot:cell(nb_of_docs_eu)="data">
                <div class="input-group input-group-sm single-number-field">
                  <input type="number" min="0" step="1" v-model="data.item.eu_mail" class="form-control" @change="calcResult(data.item)" />
                </div>
              </template>

              <template v-slot:cell(nb_of_docs_row)="data">
                <div class="input-group input-group-sm single-number-field">
                  <input type="number" min="0" step="1" v-model="data.item.row_mail" class="form-control" @change="calcResult(data.item)" />
                </div>
              </template>

              <template v-slot:cell(nb_of_docs_franked)="data">
                <div class="input-group input-group-sm single-number-field">
                  <input type="number" min="0" step="1" v-model="data.item.frnk_mail" class="form-control" @change="calcResult(data.item)" />
                </div>
              </template>

              <template v-slot:cell(nb_of_docs_nc)="data">
                <div class="input-group input-group-sm single-number-field">
                  <input type="number" min="0" step="1" v-model="data.item.unsent" class="form-control" @change="calcResult(data.item)" />
                </div>
              </template>

              <template v-slot:cell(nb_of_docs_total)="data">
                {{data.item.total_docs}}
              </template>

              <template v-slot:cell(nb_of_docs_result)="data">
                {{data.item.result}}
              </template>

              <template v-slot:cell(selling_price_franked)="data">
                <div class="input-group input-group-sm single-number-field">
                  <input type="number" min="0" step="1" v-model="data.item.frnk_charge" class="form-control" />
                </div>
              </template>

              <template v-slot:cell(selling_price_extra)="data">
                <div class="input-group input-group-sm single-number-field">
                  <input type="number" min="0" step="1" v-model="data.item.extra_charge" class="form-control" />
                </div>
              </template>

              <template v-slot:cell(selling_price_total)="data">
                {{data.item.total_charge}}
              </template>

              <template v-slot:cell(completed_by)="data">
                <div class="input-group input-group-sm single-number-field">
                  <input type="number" min="0" step="1" v-model="data.item.completed_by" class="form-control" />
                </div>
              </template>

              <template v-slot:cell(completed_date)="data">
                <div class="input-group input-group-sm single-number-field">
                  <input type="text" v-model="data.item.completed_date" class="form-control" />
                </div>
              </template>

              <template v-slot:cell(completed_cb)="data">
                <input type="checkbox" v-model="data.item.is_completed" class="form-control" :disabled="data.item.result != 0" @change="() => toggleCompleted(data.item)" />
              </template>

              <template v-slot:cell(resend)="data">
                <div class="btn btn-sm btn-primary" @click="() => resend(data.item)">Resend</div>
              </template>

              <template v-slot:cell(set_status)="data">
                <div class="btn btn-sm btn-primary" @click="() => setStatus(data.item)">Set Status</div>
              </template>

              <template slot="bottom-row">
                <td colspan="2"></td>
                <td colspan="2">Totals:</td>

                <td>{{ sum.uk_mail | asNumber(2) }}</td>
                <td>{{ sum.eu_mail | asNumber(2) }}</td>
                <td>{{ sum.row_mail | asNumber(2) }}</td>
                <td>{{ sum.frnk_mail | asNumber(2) }}</td>
                <td>{{ sum.unsent | asNumber(2) }}</td>
                <td>{{ sum.total_docs | asNumber(2) }}</td>
                <td>{{ sum.result | asNumber(2) }}</td>
                <td>{{ sum.frnk_charge | asNumber(2) }}</td>
                <td>{{ sum.extra_charge | asNumber(2) }}</td>
                <td>{{ sum.total_charge | asNumber(2) }}</td>

                <td colspan="5"></td>
              </template>

            </b-table>
            <div class="row">
              <div class="offset-md-8 col-md-4 offset-lg-8 col-lg-4 mb-2 mb-md-0">
                <p>&nbsp;</p>
                <b-pagination class="float-right mb-0" v-model="currentPage" @input="onPerPageChange" :per-page="perPage" :total-rows="postingTrackerCount" aria-controls="track-invoices-table" v-if="postingTrackerCount > perPage"></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import { VclTable } from 'vue-content-loading'
import datePicker from 'vue-bootstrap-datetimepicker'
import { getDefaultConfig } from "../../helpers/datepickerHerler";
import axios from "../../axios";
import moment from "moment";

export default {
  name: 'PostingTrack',
  components:{
    VclTable,
    datePicker,
  },
  data () {
    return {
      fields: [
        {key: 'entry_date', label: 'Date', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'batch_id', label: 'Batch', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'filename', label: 'File Name', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'pages', label: 'Pages', sortable: false, thClass: 'hover-pointer brand-color'},

        {key: 'nb_of_docs_uk', label: 'UK', sortable: false, thClass: 'hover-pointer brand-color'},
        {key: 'nb_of_docs_eu', label: 'EU', sortable: false, thClass: 'hover-pointer brand-color'},
        {key: 'nb_of_docs_row', label: 'RoW', sortable: false, thClass: 'hover-pointer brand-color'},
        {key: 'nb_of_docs_franked', label: 'Franked', sortable: false, thClass: 'hover-pointer brand-color'},
        {key: 'nb_of_docs_nc', label: 'NC', sortable: false, thClass: 'hover-pointer brand-color'},
        {key: 'nb_of_docs_total', label: 'Total', sortable: false, thClass: 'hover-pointer brand-color'},
        {key: 'nb_of_docs_result', label: 'Result', sortable: false, thClass: 'hover-pointer brand-color'},

        {key: 'selling_price_franked', label: 'Franked', sortable: false, thClass: 'hover-pointer brand-color'},
        {key: 'selling_price_extra', label: 'Extra', sortable: false, thClass: 'hover-pointer brand-color'},
        {key: 'selling_price_total', label: 'Total', sortable: false, thClass: 'hover-pointer brand-color'},

        {key: 'completed_by', label: 'By', sortable: false, thClass: 'hover-pointer brand-color'},
        {key: 'completed_date', label: 'Date', sortable: false, thClass: 'hover-pointer brand-color'},
        {key: 'completed_cb', label: '', sortable: false, thClass: 'hover-pointer brand-color'},

        {key: 'resend', label: '', sortable: false, thClass: 'hover-pointer brand-color'},
        {key: 'set_status', label: '', sortable: false, thClass: 'hover-pointer brand-color'},
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      filterData: {
        client: "",
        batches: [],
        from: null,
        to: null,
        completed: "",
      },
      loading: false,
      isFilterVisible: true,
      datePickerFrom: {},
      datePickerTo: {},
      alerts: {
        resend: {status: null, message: ""},
        setStatus: {status: null, message: ""},
      },
    }
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    loadPostingTrackerFilter() {
      this.$store.dispatch('loadPostingTrackerFilter', {
        client: this.filterData.client,
      })
    },
    loadPostingTracker() {
      this.loading = true

      let filter = {...this.filterData};
      filter.batches = this.filterData.batches.map(b => b.id);

      this.$store.dispatch('loadPostingTracker', {
        start: (this.currentPage * this.perPage) - this.perPage,
        perPage: this.perPage,
        isTester: this.$store.getters.getUserDetails.is_tester,
        filter: filter,
      }).finally(() => {
        this.loading = false
      })
    },
    onPerPageChange() {
      if (this.perPage < 1) {
        this.perPage = 1;
      }
      this.loadPostingTracker()
    },
    onClientChange() {
      this.loadPostingTrackerFilter()
      this.loadPostingTracker()
    },
    onBatchChange() {
      this.loadPostingTracker()
    },
    async resend(item) {
      let response = await axios().post(`/postingTrackerResend`, {
        client: item.client || null,
        batch: item.batch_id || null,
        file: item.filename || null,
      })

      if (response.data.status === "success") {
        this.alerts = {...this.alerts, resend: {status: "success", message: "Documents are being resent to the postroom"}}
      }

      setTimeout(() => {
        this.alerts = {...this.alerts, resend: {status: null, message: null}}
      }, 3500);
    },
    async setStatus(item) {
      let datetime = prompt ("Please enter the start date/time for marking this block of documents as folded.\n\n Use the format: DD/MM/YYYY HH:MM:SS", "");
      if (datetime != null && datetime != "")
      {
        let response = await axios().post(`/postingTrackerSetStatus`, {
          batch: item.batch_id,
          client: item.client,
          file: item.filename,
          datetime: datetime,
        })

        if (response.data.status === "success") {
          this.alerts = {...this.alerts, setStatus: {status: "success", message: "Documents send status is being set"}}
        }

        setTimeout(() => {
          this.alerts = {...this.alerts, setStatus: {status: null, message: null}}
        }, 3500);
      }

    },
    getRowClass(item) {
      if (!item) return null;

      if (item.is_completed || item.completed_by || item.completed_date) {
        return null;
      }

      return {style: "background-color: #FFFF66;"};
    },
    calcResult(item) {
      if (!item) return;
      let ukMail = Number.parseInt(item.uk_mail) || 0;
      let euMail = Number.parseInt(item.eu_mail) || 0;
      let rowMail = Number.parseInt(item.row_mail) || 0;
      let franked = Number.parseInt(item.frnk_mail) || 0;
      let unsent = Number.parseInt(item.unsent) || 0;
      item.result = item.total_docs - (ukMail + euMail + rowMail + franked + unsent)
    },
    async toggleCompleted(item) {
      await axios().post(`/postingTrackerUpdate/${item.id}`, item)
      this.loadPostingTracker()
    }
  },
  computed:{
    postingTracker: {
      get() {
        return this.$store.getters.getPostingTracker
      }
    },
    postingTrackerCount: {
      get() {
        return this.$store.getters.getPostingTrackerCount
      }
    },
    postingTrackerFilter: {
      get() {
        return this.$store.getters.getPostingTrackerFilter
      }
    },
    sum: {
      get() {
        return this.$store.getters.getPostingTrackerSummary
      }
    },
    datePickerFormat() {
      if(this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
        let dateformat = this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
        return dateformat
      } else {
        return "DD-MM-YYYY"
      }
    },
  },
  created() {
    let weekAgo = moment();
    weekAgo.subtract(7, "d");
    this.filterData.completed = "n";
    this.filterData.from = weekAgo.format("DD-MM-YYYY");
    this.datePickerFrom = getDefaultConfig(this.datePickerFormat);
    this.datePickerTo = getDefaultConfig(this.datePickerFormat);
    this.loadPostingTrackerFilter()
    this.loadPostingTracker()
  },
}

</script>

<style scoped>
table >>> tbody, table >>> thead{
  text-align: center;
}
.table  >>> .brand-color {
  background-color: #047bf8 !important;
  color: white !important;
}

.single-number-field {
  max-width: 64px;
}
</style>
